import { render, staticRenderFns } from "./TheTodayStatisticsTable.vue?vue&type=template&id=4ed1a0e6"
import script from "./TheTodayStatisticsTable.vue?vue&type=script&lang=js"
export * from "./TheTodayStatisticsTable.vue?vue&type=script&lang=js"
import style0 from "./TheTodayStatisticsTable.vue?vue&type=style&index=0&id=4ed1a0e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTable from 'quasar/src/components/table/QTable.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTable,QInnerLoading,QTh,QIcon,QTooltip,QTd});
